<template>
  <div class="form__field-group form__field--text">
    <div>
      <label :for="inputId">{{ label }} <span v-if="required">*</span> </label>
      <select
        :id="inputId"
        :title="inputName"
        @change="onChange"
        :class="{ error: error }"
      >
        <option v-for="opt in options" :key="opt.key" :value="opt.value">
          {{ opt.key }}
        </option>
      </select>
      <div v-show="error !== undefined" class="error-text">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    value: { type: String, default: "" },
    options: { type: Array, default: () => [] },
    onChange: { type: Function, default: () => undefined },
    required: { type: Boolean, required: false, default: () => false },
    error: { type: String, default: undefined },
  },
  computed: {
    inputName() {
      return `${this.label
        .toLowerCase()
        .replaceAll(" ", "-")
        .replaceAll(".", "")}`;
    },
    inputId() {
      return `forminput-${this.label.toLowerCase().replaceAll(" ", "-")}`;
    },
  },
};
</script>

<style scoped>
.error-text {
  color: red;
}
.error {
  border: 3px solid red;
}
</style>
